export class spotLight {
  private parent: PIXI.Container;
  private lightSocket: PIXI.Sprite;
  private lightRay: PIXI.Sprite;
  private lightAngle: number;
  private lightMaxRotatePerSideAngle: number;
  private flipAnim:boolean;
  private randomColorsTint:Array<number>;
  //--animations
  private tweenAnimation: PIXI.tween.Tween;
  constructor(parent: PIXI.Container) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.lightAngle = 0;
    this.lightMaxRotatePerSideAngle = 30;
    this.lightMaxRotatePerSideAngle ;
    this.lightAngle ;
    this.flipAnim=false;
    this.randomColorsTint=[0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,0xFF5522,0xFF5522,0x5522FF,0x55FF55,0x52F0FF,0xFABCFF,0xF08822,0xf2f2c6]
    this.lightSocket = new PIXI.Sprite(
      PIXI.Texture.fromFrame("lightSmall.png")
    );
    this.parent.addChild(this.lightSocket);
    this.lightRay = new PIXI.Sprite(PIXI.Texture.fromFrame("lightWhite.png")); //use hue to make it random
    this.lightRay.y=15;
    this.lightSocket.addChild(this.lightRay);

    this.lightRay.blendMode=PIXI.BLEND_MODES.SCREEN_NPM; 


    let lightCore=new PIXI.Sprite(PIXI.Texture.fromFrame("lightWhite.png")); //use hue to make it random
    lightCore.scale.set(.35,1);
    this.lightRay.addChild(lightCore);
    lightCore.alpha=.5;
    lightCore.blendMode=PIXI.BLEND_MODES.ADD;

    this.tweenAnimation = PIXI.tweenManager.createTween(this.lightSocket);
    this.tweenAnimation
      .from({
        rotation:
          ((this.lightAngle + this.lightMaxRotatePerSideAngle) * Math.PI) / 180,
      })
      .to({
        rotation:
          ((this.lightAngle - this.lightMaxRotatePerSideAngle) * Math.PI) / 180,
      })
    this.tweenAnimation.time = 4500;
    this.tweenAnimation.easing = PIXI.tween.Easing.inOutSine();
    this.tweenAnimation.pingPong = true;
    this.tweenAnimation.loop = true;
    this.tweenAnimation.stop();
    this.setVisible(false);
  }
  
  public flipAnimation=(bool:boolean):void=>
  {
      this.flipAnim=bool;
      if(bool)
      {
        this.tweenAnimation
        .from({
          rotation:
            ((this.lightAngle - this.lightMaxRotatePerSideAngle) * Math.PI) / 180,
        })
        .to({
          rotation:
            ((this.lightAngle + this.lightMaxRotatePerSideAngle) * Math.PI) / 180,
        })
      }
      else
      {
        this.tweenAnimation
        .from({
          rotation:
            ((this.lightAngle + this.lightMaxRotatePerSideAngle) * Math.PI) / 180,
        })
        .to({
          rotation:
            ((this.lightAngle - this.lightMaxRotatePerSideAngle) * Math.PI) / 180,
        })
      }
   
  }
  public setVisible=(bool:boolean):void=>
  {
    //  this.setLightOn(bool);
    // console.log("SET+++",bool)

     if (bool) {
      this.tweenAnimation.start();
      this.parent.alpha = 1;
    } else {
      this.tweenAnimation.stop();
      this.parent.alpha = 0;
    }
  }

  
  public setLightScale=(newScale:number)=>
  {
      this.lightRay.scale.set(newScale);
  }
  public getAnimationTween=():PIXI.tween.Tween=>
  {
      return this.tweenAnimation;
  }
  public setLightPointingAngleInDegree = (lightAngle: number): void => {
    this.lightAngle = lightAngle;
    this.flipAnimation(this.flipAnim);
  };

  public setLightMaxRotatePerSideAngleInDegree = (
    lightSideAngle: number
  ): void => {
    this.lightMaxRotatePerSideAngle = lightSideAngle;
    this.flipAnimation(this.flipAnim);
  };

  public setTintIndex=(index:number):void=>
  {
    this.lightRay.tint=this.randomColorsTint[index];
  }

  public setTint=(newTintvalue:number):void=>
  {
    this.lightRay.tint=newTintvalue;
  }
  public enableRandomColorsLight = (bool: boolean): void => {

    if (bool)
    {

        let  randomTint = Math.floor(Math.random() * this.randomColorsTint.length);

        this.lightRay.tint=this.randomColorsTint[randomTint]
        // let aturateMatrix = new PIXI.filters.ColorMatrixFilter();
        // aturateMatrix.polaroid(true)
        // aturateMatrix.reset();
        // this.lightRay.filters=[aturateMatrix];
    }
    else
    {
        this.lightRay.tint=0xFFFFFF;
    }

   
  };
  // private setLightOn = (bool: boolean): void => {
  //   if (bool) {
  //     this.tweenAnimation.start();
  //     this.parent.alpha = 1;
  //   } else {
  //     this.tweenAnimation.stop();
  //     this.parent.alpha = 0;
  //   }
  // };
  public setPositin=(pos:Array<number>):void=>
  {
      this.parent.x=pos[0];
      this.parent.y=pos[1];
  }
}


export class BlinkLightArrayBuilder
{
    private parent: PIXI.Container;
    private Lights: Array<blinkingLight>;
    constructor(parent: PIXI.Container, counts:number, alignementHoizontal:boolean, spacing:number) {
        this.parent = new PIXI.Container();
        parent.addChild(this.parent);



        this.Lights=[];
        for (let i = 0; i < counts; i++) {
            this.Lights[i]= new blinkingLight(this.parent);
            if(alignementHoizontal)
            {
                this.Lights[i].setPositin([i*spacing,0]);
            }
           else{
            this.Lights[i].setPositin([0,i*spacing]);
           }
            this.Lights[i].setLightOn(false);
            
        }
    }

    public setScale=(newScale:number)=>
    {
     this.parent.scale.set(newScale)
    }
    public setCenteredYPosition=(parentSize:number):void=>
    {
        this.parent.y=parentSize/2-this.parent.height/2;
    }

    public setCenteredXPosition=(parentSize:number):void=>
    {
        this.parent.x=parentSize/2-this.parent.width/2+this.Lights[0].getParent().width/2;
    }

    public setPosition=(pos:Array<number>):void=>
    {
        this.parent.x=pos[0];

        this.parent.y=pos[1];
    }
    public hideSelected=(indexList:Array<number>):void=>
    {

      for (let i = 0; i < indexList.length; i++) {
        this.Lights[indexList[i]].setLightOn(false);
        this.Lights[indexList[i]].setVisible(false);
      }
    }

    public setVisible=(bool:boolean):void=>
    {
      for (let i = 0; i < this.Lights.length; i++) {
        this.Lights[i].setLightOn(bool);
        
      }
    }
}
 class blinkingLight {
    private parent: PIXI.Container;
    private lightSocket: PIXI.Sprite;
    private lightRay: PIXI.Sprite;
    // private lightAngle: number;
    // private lightMaxRotatePerSideAngle: number;
    // private flipAnim:boolean;
    private isHidden:boolean;
    private randomColorsTint:Array<number>;
    //--animations
    private tweenAnimation: PIXI.tween.Tween;
    
    constructor(parent: PIXI.Container) {
      this.parent = new PIXI.Container();
      parent.addChild(this.parent);
      this.isHidden=false;
      this.randomColorsTint=[0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,0xFF5522,0xFF5522,0x5522FF,0x55FF55,0x52F0FF,0xFABCFF,0xF08822]
      this.lightSocket = new PIXI.Sprite(
        PIXI.Texture.fromFrame("lightOff.png")
      );
      this.lightSocket.scale.set(.7)
      this.parent.addChild(this.lightSocket);
      this.lightRay = new PIXI.Sprite(PIXI.Texture.fromFrame("lightOn.png")); //use hue to make it random

     
      this.lightSocket.addChild(this.lightRay);
      this.lightRay .scale.set(1.2)
      this.lightRay.blendMode=PIXI.BLEND_MODES.SCREEN_NPM; 
  
      this.tweenAnimation = PIXI.tweenManager.createTween(this.lightRay);
      this.tweenAnimation
        .from({
          alpha:0,
        })
        .to({
          alpha:1,
        })
      this.tweenAnimation.time = 1500; //get speed from winline animation
      this.tweenAnimation.easing = PIXI.tween.Easing.inOutElastic();
      this.tweenAnimation.pingPong = true;
      this.tweenAnimation.loop = true;
      // this.tweenAnimation.start();
      this.setLightOn(false);
    }

 
    public getParent=():PIXI.Container=>
    {
        return this.parent
    }
  
    public setLightScale=(newScale:number)=>
    {
        this.lightRay.scale.set(newScale);
    }
    public getAnimationTween=():PIXI.tween.Tween=>
    {
        return this.tweenAnimation;
    }
  
  
    public enableRandomColorsLight = (bool: boolean): void => {
  
      if (bool)
      {
  
          let  randomTint = Math.floor(Math.random() * this.randomColorsTint.length);
  
          this.lightRay.tint=this.randomColorsTint[randomTint]
          // let aturateMatrix = new PIXI.filters.ColorMatrixFilter();
          // aturateMatrix.polaroid(true)
          // aturateMatrix.reset();
          // this.lightRay.filters=[aturateMatrix];
      }
      else
      {
          this.lightRay.tint=0xFFFFFF;
      }
  
     
    };
    public setLightOn = (bool: boolean): void => {
      if (bool && this.isHidden==false) {
        this.tweenAnimation.start();
        this.lightRay.alpha = 1;
      } else {
        this.tweenAnimation.stop();
        this.lightRay.alpha = 0;
      }
      // console.log("BOOL",bool)
    };
    public setVisible=(bool: boolean):void => {
      this.parent.alpha = bool?1:0;
      this.isHidden=bool;
      this.setLightOn(false);
    }
      
    public setPositin=(pos:Array<number>):void=>
    {
        this.parent.x=pos[0];
        this.parent.y=pos[1];
    }
  }



 export  class expandingLight{
    private parent :PIXI.Container;
    private arrayLights:Array<PIXI.Sprite>;
    private arrayLightTween:Array<PIXI.tween.Tween>;
    constructor(parent:PIXI.Container,flipside=false)
    {

      this.parent= new PIXI.Container();
      parent.addChild(this.parent)
      this.arrayLights=[];
      this.arrayLightTween=[];
      for (let i = 0; i <30 ; i++) {
        this.arrayLights[i]= new PIXI.Sprite(PIXI.Texture.fromFrame("lightWhite.png"));
        this.parent.addChild(this.arrayLights[i]);
        this.arrayLights[i].rotation=(90+(15*i))*Math.PI/180;
        this.arrayLights[i].y=1080+i*-50;
        this.arrayLights[i].x=300;
        this.arrayLights[i].tint=0xF08822;


        let core= new PIXI.Sprite(PIXI.Texture.fromFrame("lightWhite.png"));
        core.scale.set(.25,1);
        core.blendMode=PIXI.BLEND_MODES.ADD;
        this.arrayLights[i].addChild(core);
        // this.arrayLights[i].rotation=(90+(15*i))*Math.PI/180;
        // this.arrayLights[i].y=1080+i*-50;
        // this.arrayLights[i].x=300;
        // core.tint=0xF08822;

      if(flipside==false)
      {
        this.arrayLights[i].rotation=(-90-(15*i))*Math.PI/180;
        
        this.arrayLights[i].x=1920-300;

       
      }
       
        this.arrayLights[i].blendMode=PIXI.BLEND_MODES.ADD;
        // this.arrayLights[i].alpha=.2;
     
  
        this.arrayLightTween[i] = PIXI.tweenManager.createTween(this.arrayLights[i]);
        this.arrayLightTween[i]
          .from({
            scale:{x:0,y:0},
            alpha:1
          })
          .to({
            scale:{x:2,y:4},
            alpha:0
          })
          this.arrayLightTween[i].time = 1500; //get speed from winline animation
          this.arrayLightTween[i].easing = PIXI.tween.Easing.linear();
          // this.arrayLightTween[i].pingPong = true;
          this.arrayLightTween[i].loop = true;
          // this.arrayLightTween[i].start();
      }
  
    }
    public setPosition=(posX:number,posY:number):void=>
    {
      this.parent.position.set(posX,posY);
    }
    public getparent=():PIXI.Container=>
    {
     return this.parent;
    }
    public setRotation=(newAngle:number):void=>
    {
      this.parent.rotation=newAngle*Math.PI/180;//
    }
    public setLightOn=(bool:boolean):void=>
    {
      this.parent.alpha=bool?1:0;
      for (let i = 0; i < this.arrayLightTween.length; i++) {
        
        if(bool)
        {
          this.arrayLightTween[i].start();
        }
        else
        {
          this.arrayLightTween[i].stop();
        }
        
        
      }
    }
  }